import React from 'react';
import { htmlDecode } from '../../utils/';

export const BasePageItem = (props) => {

    return (
        <div className="col-lg-12">
            <article>
                <a target={props.urlTarget && props.urlTarget === '_blank' ? '_blank' : ''} href={props.pageUrl}>
                    <h3 className={`card-title`}>{props.documentName}</h3>
                    <p className="card-desc content search-card-desc">{htmlDecode(props.searchDescription)}</p>
                </a>
            </article>
        </div>
    );
}